export default {
  // HTwbCardHome.vue strings
  title: "HTcard",
  login: "Login",
  logout: "Logout",
  
  // Search related
  searchPlaceholder: "Search collection board titles...",
  clearSearch: "Clear search",
  searching: "Searching...",
  searchResults: "Found {count} results",
  
  // Collection board related
  addCollectBoard: "Add Collection Board\n(CardCollect)",
  collectBoardStatus: {
    openSubmit: "Open Submit",
    closeSubmit: "Close Submit"
  },
  
  // Not logged in state
  welcome: {
    title: "Welcome to HTcard",
    message: "Please log in to start using the card collection feature"
  },
  
  // Modal titles
  modals: {
    createTitle: "Add Collection Board",
    editTitle: "Update Collection Board Settings", 
    deleteTitle: "Confirm Delete Collection Board"
  },
  
  // Forms
  forms: {
    collectBoardName: "Please enter collection board name",
    openSubmitLabel: "Open Submit",
    cancel: "Cancel",
    create: "Create",
    update: "Update",
    delete: "Delete",
    setting: "Settings"
  },
  
  // Delete confirmation
  deleteConfirm: {
    message: "Are you sure you want to delete collection board \"{name}\"?",
    warning: "Warning: This operation will delete all cards and their files in the collection board and cannot be undone. Please confirm carefully!",
    deleting: "Deleting...",
    confirmDelete: "Confirm Delete"
  },
  
  // Message prompts
  messages: {
    loginSuccess: "Login successful!",
    loginFailed: "Login failed",
    logoutSuccess: "Logout successful",
    logoutFailed: "Logout failed",
    loadFailed: "Load failed",
    createSuccess: "Created successfully!",
    createFailed: "Create failed",
    updateSuccess: "Updated successfully!",
    updateFailed: "Update failed",
    deleteSuccess: "Collection board deleted successfully!",
    deleteFailed: "Delete failed, please try again later",
    searchFailed: "Search failed, please try again later",
    alreadyCopied: "Copied to clipboard"
  },

  // HTwbCardCollect.vue strings
  collect: {
    loading: "Loading...",
    loadFailed: "Load failed",
    
    // Search
    searchCardPlaceholder: "Search card names or creators...",
    searchResultsCount: "Found {count} results",
    
    // Color filter
    colorFilter: "Color Filter",
    colorTitle: "Colors",
    clearFilter: "Clear",
    colors: {
      white: "White",
      lightYellow: "Light Yellow",
      lightGreen: "Light Green",
      lightBlue: "Light Blue",
      lightPink: "Light Pink"
    },
    
    // Buttons
    uploadCard: "Upload New Card",
    addGroup: "Add Group",
    share: "Share",
    shareCard: "Share Card Collection",
    
    // Media playback errors
    videoNotSupported: "Your browser does not support video playback",
    audioNotSupported: "Your browser does not support audio playback", 
    imageLoadFailed: "Image failed to load",
    
    // Upload card Modal
    uploadModal: {
      title: "Upload New Card",
      cardName: "Card Name *",
      cardNamePlaceholder: "Please enter card name",
      selectGroup: "Select Group",
      textContent: "Text Content (Optional)",
      textContentPlaceholder: "Enter your text content here...",
      cardColor: "Card Color",
      selectFile: "Select File (Optional)",
      dragDropFile: "Click to select file or drag and drop file here",
      fileHint: "All file formats supported",
      fileSizeHint: "File size limit: {size}MB",
      removeFile: "Remove File",
      uploading: "Uploading...",
      uploadCard: "Upload Card",
      cancel: "Cancel"
    },
    
    // Edit card Modal
    editModal: {
      title: "Edit Card",
      currentFile: "Current File:",
      replaceFile: "Replace File",
      removeCurrentFile: "Remove Current File",
      updating: "Updating...",
      confirmUpdate: "Confirm Update"
    },
    
    // Delete card confirmation
    deleteCardConfirm: {
      title: "Confirm Delete",
      message: "Are you sure you want to delete card \"{name}\"?",
      warning: "This operation cannot be undone and will permanently delete the card and its files.",
      deleting: "Deleting...",
      confirmDelete: "Confirm Delete",
      cancel: "Cancel"
    },
    
    // Add group Modal
    addGroupModal: {
      title: "Add Group",
      groupName: "Group Name *",
      groupNamePlaceholder: "Please enter group name",
      adding: "Adding...",
      confirmAdd: "Confirm Add",
      cancel: "Cancel"
    },
    
    // Card menu
    cardMenu: {
      edit: "Edit",
      delete: "Delete"
    },
    
    // Default group
    defaultGroup: "Group 1",
    
    // File types
    fileTypes: {
      unknown: "Unknown File",
      image: "Image",
      video: "Video",
      audio: "Audio",
      word: "Word Document",
      pdf: "PDF Document", 
      text: "Text File",
      zip: "ZIP Archive",
      rar: "RAR Archive",
      general: "General File",
      textFile: "Text File",
      applicationFile: "Application File"
    },
    
    // Upload status
    uploadStatus: {
      preparing: "Preparing to upload...",
      creating: "Creating card record...",
      uploading: "Uploading file... ({uploaded}MB / {total}MB)",
      updating: "Updating card information...",
      saving: "Saving text card...",
      completed: "Upload completed!",
      textCardCreated: "Text card created successfully!",
      failed: "Upload failed"
    },
    
    // Error messages
    errors: {
      cardNameRequired: "Please enter card name",
      cardNameTooLong: "Card name cannot exceed 50 characters",
      contentRequired: "Please enter text content or select a file",
      textOrFileRequired: "Please enter text content or keep/select a file",
      fileSizeExceeded: "File size cannot exceed {size}MB",
      groupNameRequired: "Please enter group name",
      groupNameTooLong: "Group name cannot exceed 20 characters",
      groupNameExists: "Group name already exists",
      missingUserInfo: "Unable to get user information, please refresh the page",
      missingIdInfo: "Missing required ID information",
      sasTokenExpired: "SAS Token has expired, please refresh the page",
      fileUploadFailed: "File upload failed, please check network connection",
      updateDataError: "Request data error: {error}",
      cardNotFound: "Card to update not found",
      noPermission: "No permission to perform this operation",
      authFailed: "Authentication failed, please refresh the page",
      networkError: "Network error, please check connection",
      generalError: "Operation failed, please try again later",
      copyFailed: "Copy failed",
      updateFailed: "Update failed"
    },
    
    // Success messages
    successMessages: {
      cardUploaded: "Card uploaded successfully!",
      textCardCreated: "Text card created successfully!",
      cardUpdated: "Card updated successfully!",
      cardDeleted: "Card deleted successfully!",
      cardMoved: "Card moved to new group",
      groupAdded: "Group added successfully!",
      settingsUpdated: "Settings updated"
    },
    
    // User identity
    userIdentity: {
      loggedInUser: "Logged In User",
      anonymousUser: "Anonymous User",
      systemUser: "System"
    },
    
    // Comments
    comments: {
      placeholder: "type comment...",
      published: "Comment published",
      updated: "Comment updated",
      deleted: "Comment deleted", 
      publishFailed: "Failed to publish comment",
      updateFailed: "Failed to update comment",
      deleteFailed: "Failed to delete comment",
      edit: "Edit Comment",
      delete: "Delete Comment",
      justNow: "just now",
      minutesAgo: "{minutes} minutes ago",
      hoursAgo: "{hours} hours ago", 
      daysAgo: "{days} days ago",
      // Edit attachments
      removeAttachment: "Remove Attachment",
      addAttachment: "Add Attachment",
      replaceAttachment: "Replace Attachment",
      contentRequired: "Comment content or attachments cannot be empty",
      fileTooLarge: "File {fileName} is too large (over 5MB)",
      fileUploaded: "File {fileName} uploaded successfully",
      fileUploadFailed: "Failed to upload file {fileName}",
      fileProcessFailed: "File processing failed",
      save: "Save",
      cancel: "Cancel"
    }
  }
};